import React from 'react';
import { Field } from '../../ui/Field';
import { TextArea, SelectControl } from '../../ui/TextControl';
import { ConsentCheckbox } from '../../ui/ChoiceChip';
import { asDraft } from '../../../types/registration';
import { ATTRIBUTION_OPTIONS } from '../../../data/registration';
import type { QuestionProps } from './types';
const MAX_MEMORY = 600;
export function MemoryQuestion({
  data,
  update
}: QuestionProps) {
  const draft = asDraft(data);
  const hasMemory = draft.memory.trim().length > 0;
  return <div className="flex flex-col gap-5" data-id="element-438" data-mp="3vaarhygkre7m">
      <Field name="memory" label="Something you remember" hint={`${draft.memory.length} of ${MAX_MEMORY}`} data-id="element-439" data-mp="3v99h7w7duvqy">
        <TextArea id="memory" name="memory" rows={5} maxLength={MAX_MEMORY} placeholder="The night the power went out and the meeting kept going by flashlight…" value={draft.memory} onChange={event => update({
        memory: event.target.value
      })} data-id="element-440" data-mp="3hgjo77tfsqkc" />
      </Field>

      {hasMemory ? <>
          <Field name="attribution" label="Signed how?" data-id="element-441" data-mp="1hootanpzvazj">
            <SelectControl id="attribution" name="attribution" value={draft.attribution} options={ATTRIBUTION_OPTIONS} onChange={event => update({
          attribution: event.target.value
        })} data-id="element-442" data-mp="1dn3m9j055qx9" />
          </Field>

          <ConsentCheckbox id="shareMemory" checked={draft.shareMemory} onChange={checked => update({
        shareMemory: checked
      })} data-id="element-443" data-mp="21c4pmru4abvo">
            Add it to the archive once a staff member has read it. Unchecked, it stays private
            to you.
          </ConsentCheckbox>
        </> : null}

      <div className="border-t border-rule pt-4" data-id="element-444" data-mp="25f190krhec0o">
        <ConsentCheckbox id="agreed" checked={draft.agreed} onChange={checked => update({
        agreed: checked
      })} data-id="element-445" data-mp="fytjv2wg115m">
          I&apos;ve read how the portal treats what I share, and I&apos;d like to join.
        </ConsentCheckbox>
      </div>
    </div>;
}